import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'create_department_lists';
export const useCreateDepartmentListsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить',
    toast_error: 'Не удалось создать новый список',
    toast_success: 'Список успешно создан',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add',
    toast_error: 'Failed to create new list',
    toast_success: 'The list has been successfully created',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar',
    toast_error: 'Falha ao criar nova lista',
    toast_success: 'A lista foi criada com sucesso',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Agregar',
    toast_error: 'No se pudo crear la nueva lista.',
    toast_success: 'La lista se ha creado correctamente',
  },
}) : {}) as Record<string, unknown>;
